import { render, staticRenderFns } from "./new-credit-card.vue?vue&type=template&id=5cd35be2&"
import script from "./new-credit-card.vue?vue&type=script&lang=js&"
export * from "./new-credit-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports